import React from 'react'
import List from './list'

const WebinarCategories = props => (
  <List categoryType='webinar' {...props} />
)

export default WebinarCategories
